import {React} from 'react'
import {Card} from 'react-bootstrap'
import PdfIcon from 'assets/icons/pdf.png'
import WordIcon from 'assets/icons/word.png'
import JpegIcon from 'assets/icons/jpeg.png'
import PngIcon from 'assets/icons/png.png'
import TextIcon from 'assets/icons/text.png'
import UnknownIcon from 'assets/icons/unknown.png'

export const iconMap = {'image/tiff':JpegIcon,'image/x-tiff':JpegIcon,'image/jpeg':JpegIcon,'application/pdf':PdfIcon,'image/png':PngIcon,'text/plain':TextIcon,'application/msword':WordIcon,
'application/vnd.openxmlformats-officedocument.wordprocessingml.document':WordIcon,
'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document':WordIcon}

export const iconMapFileType = {'tif':JpegIcon,'tiff':JpegIcon,'jpg':JpegIcon,'jpeg':JpegIcon,'pdf':PdfIcon,'png':PngIcon,'text':TextIcon,'msword':WordIcon,
'doc':WordIcon,
'docx':WordIcon}

export const FileIconPreview = ({file})=>{    
    if(['image/jpeg', 'application/pdf', 'image/png'].includes(file.type)) {
      return <img
        src={file.preview}
        alt={file?.name}
        className="w-100 dz-image"
        style={{ objectFit: 'contain', display: 'block',height:'160px' }}
      />
    }else if(iconMap[file.type]){
      return <Card.Img
          variant="top"
          src={iconMap[file.type]}
          alt={file?.name}     
          style={{width: '128px',height: '128px'}}
      />
    }else{
      return <Card.Img
      variant="top"
      src={UnknownIcon}
      alt={file?.name}     
      style={{width: '128px',height: '128px'}}
  />
    }
  }

const FileIconImg = ({file})=>{

    const renderIcon = (file)=>{
    
        if(iconMap[file?.type]){
          return <Card.Img
          variant="top"
          src={iconMap[file?.type]}
          alt={file.name}     
          style={{width: '24px',height: '24px'}}
      />
        }else if(iconMapFileType[file?.fileType]){
            return <Card.Img
            variant="top"
            src={iconMapFileType[file?.fileType]}
            alt={file.name}     
            style={{width: '24px',height: '24px'}}
        />
        }else{
          return <Card.Img
          variant="top"
          src={UnknownIcon}
          alt={file?.name}     
          style={{width: '24px',height: '24px'}}
      />
        }
    
        
    }

    return renderIcon(file)
}

export default FileIconImg;